import React, { useState } from "react";
import "./AddUserModal.css"; // Reuse the same CSS for consistency
import { updatePassword } from "../../../api/userApi";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const ChangePasswordModal = ({ isOpen, onClose, user }) => {
  const [passwords, setPasswords] = useState({
    oldPassword: "",
    newPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPasswords((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!passwords.oldPassword) {
      newErrors.oldPassword = "Mật khẩu cũ không được để trống.";
    }
    if (!passwords.newPassword) {
      newErrors.newPassword = "Mật khẩu mới không được để trống.";
    } else if (passwords.newPassword.length < 6) {
      newErrors.newPassword = "Mật khẩu mới phải có ít nhất 6 ký tự.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      await updatePassword(
        user._id,
        passwords.oldPassword,
        passwords.newPassword
      );
      MySwal.fire({
        icon: "success",
        title: "Thành công!",
        text: `Đã cập nhật mật khẩu cho người dùng ${user.username}.`,
        timer: 2000,
        showConfirmButton: false,
      });
      handleClose();
    } catch (err) {
      const message = err.response?.data?.message || "Có lỗi xảy ra.";
      MySwal.fire({
        icon: "error",
        title: "Cập nhật thất bại",
        text: message,
      });
      console.error("Update password error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setPasswords({ oldPassword: "", newPassword: "" });
    setErrors({});
    setLoading(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Đổi mật khẩu cho "{user?.username}"</h2>
          <button className="close-button" onClick={handleClose}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="oldPassword">Mật khẩu cũ *</label>
            <input
              type="password"
              id="oldPassword"
              name="oldPassword"
              value={passwords.oldPassword}
              onChange={handleChange}
              className={errors.oldPassword ? "error" : ""}
              placeholder="Nhập mật khẩu cũ"
              disabled={loading}
            />
            {errors.oldPassword && (
              <span className="error-message">{errors.oldPassword}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="newPassword">Mật khẩu mới *</label>
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              value={passwords.newPassword}
              onChange={handleChange}
              className={errors.newPassword ? "error" : ""}
              placeholder="Nhập mật khẩu mới"
              disabled={loading}
            />
            {errors.newPassword && (
              <span className="error-message">{errors.newPassword}</span>
            )}
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={handleClose}
              disabled={loading}
            >
              Hủy
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Đang cập nhật..." : "Lưu thay đổi"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
